import { ICommerceCardProps } from "./ICard";
import Image from "next/image";

const CommerceCard: React.FC<ICommerceCardProps> = ({
  title,
  description,
  ctaText,
  onClick,
  imageUrl,
}: ICommerceCardProps) => {
  return (
    <div
      style={{ boxShadow: "5px 6px 10px -5px #000000" }}
      className="flex flex-col rounded-2xl w-[300px]"
    >
      <div className="relative rounded-t-2xl h-[240px] cursor-pointer overflow-hidden">
        {imageUrl ? (
          <Image
            src={imageUrl}
            alt={title ? `Immagine di ${title}` : ""}
            fill
            sizes="(max-width: 768px) 100vw, 300px"
            className="rounded-t-2xl scale-100 hover:scale-125 ease-in duration-500 object-cover"
            priority={false}
            unoptimized
          />
        ) : (
          <div
            aria-hidden="true"
            className="bg-gray-200 rounded-t-2xl"
            style={{ width: "100%", height: "100%" }}
          />
        )}
      </div>

      <div className="flex flex-col h-[100px] bg-white justify-center items-center p-6">
        <h2 className="w-fit text-2xl font-bold">{title}</h2>
        <p className="w-fit text-sm whitespace-nowrap">{description}</p>
      </div>

      <div
        className="w-full h-[48px] text-base cursor-pointer font-bold bg-lightblack rounded-b-2xl py-3 flex items-center justify-center text-white uppercase"
        onClick={e => onClick(e)}
      >
        {ctaText}
      </div>
    </div>
  );
};

export default CommerceCard;
